<script>
  import { _ } from 'svelte-i18n'
  import { modals, user_storefronts, flash_content, previews_storefronts_filter } from '../../stores'
  import { find } from 'lodash'
  import { deleteStorefront } from '../../services/storefronts'
  import Button from '../../elements/Button.svelte'
  import FormError from '../../elements/FormError.svelte'
  import Modal from '../../elements/Modal.svelte'
  import ButtonGroup from '../../elements/ButtonGroup.svelte'

  let modal_id = 'deleteStorefront'
  let button_busy = false
  let form_element
  let show_error = false

  $: storefront = find($user_storefronts, {'id': $previews_storefronts_filter})

  function resetModal() {
    show_error = false
    button_busy = false
  }

  async function handleSubmit(event) {
    if (!$previews_storefronts_filter) { 
      console.warn('No storefront id exists, cannot delete storefront')
      return 
    }

    button_busy = true
    show_error = false

    try {
      const response = await deleteStorefront($previews_storefronts_filter)
      // Check both response.data.success and response.success to handle both formats
      if (response.data?.success || response.success) {
        previews_storefronts_filter.reset()
        resetModal()
        modals.close()
        $flash_content = $_('flashes.storefrontDeleted')
      } else {
        show_error = true
      }
    } catch (error) {
      console.error("Error with delete storefront request", error)
      show_error = true
    }
    
    button_busy = false
  }
</script>

<Modal id={modal_id}>
  <span slot="header">
    {@html $_('modals.deleteStorefront.title', { values: { storefront_name: storefront?.name } })}
  </span>
  <span slot="content">
    <FormError bind:visible={show_error}>{$_('modals.deleteStorefront.deleteError')}</FormError>
    <form bind:this={form_element} on:submit|preventDefault="{handleSubmit}">
      <p>{$_('modals.deleteStorefront.intro')}</p>
      <p class="warning">{$_('modals.deleteStorefront.warning')}</p>
      <ButtonGroup mt={3}>
        <Button kind="delete" type="submit" busy={button_busy}>{$_('buttons.delete')}</Button>
        <Button kind="outline" on:click={() => modals.close()}>{$_('buttons.cancel')}</Button>
      </ButtonGroup>
    </form>
  </span>
</Modal>

<style>
  .warning { 
    color: var(--c-danger);
  }
</style>
